import {Component, OnInit, Input} from '@angular/core';
import {User} from "../shared/model/user";
import {UserService} from "../shared/model/user.service";
import {FormGroup, FormBuilder, Validators, AbstractControl} from "@angular/forms";
import {AbstractClassPart} from "@angular/compiler/src/output/output_ast";
import {AuthService} from "../shared/security/auth.service";

@Component({
    selector: 'user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
    @Input()
    user: User;

    myForm: FormGroup;

    name: string;
    phone: string;
    role: string;
    isSaved: boolean = false;
    intensity: number;

  public visible = false;
    public visibleAnimate = false;

    public roles = [
      { value: 'superadmin', display: 'Superadmin'},
      { value: 'admin', display: 'Admin'},
      //{ value: 'steward', display: 'Beheerder'},
      { value: 'trainer', display: 'Trainer'},
      { value: 'player', display: 'Speler'}
    ];

    public intensities = [
      {value: 100, display: 100},
      {value: 80, display: 80},
      {value: 60, display: 60}
    ];

    public currentRoles;

    constructor(private fb: FormBuilder, private userService: UserService, private authService: AuthService) {
        this.myForm = fb.group({
          'name': ['', Validators.required],
          'phone': ['', Validators.required]
        });
    }

    ngOnInit() {
      this.show();
      if(this.authService.getUserRole() === 'admin') {
        this.currentRoles = this.roles;
        this.currentRoles.splice(0, 1);
      } else {
        this.currentRoles = this.roles;
      }
      this.intensity = this.authService.getIntensityUser();
    }

    signUp() {
    }

    ngOnChanges() {
      if (this.user) {
        this.show();
        this.name = this.user.name;
        this.phone = this.user.phone;
        this.role = this.user.role;
        this.intensity = this.user.intensity ? this.user.intensity : 100;
      }
    }

    setIntensity(intensity: number) {
      this.intensity = intensity;
    }

    setUserRole(role: string) {
        this.role = role;
    }

    public show(): void {
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true);
    }

    public hide(): void {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false, 300);
    }

    public save(): void {

        var isChanged: boolean = false;
        var changedElements = {
            "name": this.user.name === this.name? this.user.name: (isChanged = true, this.name),
            "phone": this.user.phone === this.phone? this.user.phone: (isChanged = true, this.phone),
            "role": this.user.role === this.role? this.user.role: (isChanged = true, this.role),
            "intensity": this.user.intensity === this.intensity ? this.user.intensity: (isChanged = true, this.intensity)
        };

        if(isChanged) {
            this.userService.updateUser(this.user.$key, changedElements);
        }

        this.isSaved = true;
    }
}
